<template>
  <div>
    <div style="margin-bottom: 5px;">
      <el-input v-model="name" placeholder="请输入名字" suffix-icon="el-icon-search" style="width: 200px;"
                @keyup.enter.native="loadPost"></el-input>
      <el-select v-model="sex" filterable placeholder="请选择性别" style="margin-left: 5px;">
        <el-option
            v-for="item in sexs"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>

      <el-select v-model="deptId" filterable placeholder="请选择部门" style="margin-left: 5px;">
        <el-option
            v-for="item in deptList"
            :key="item.id"
            :value="item.id"
            :label="item.deptName">
        </el-option>
      </el-select>

      <el-button type="primary" style="margin-left: 5px;" @click="loadPost"> 查询</el-button>
      <el-button type="warning" @click="resetParam"> 重置</el-button>
    </div>

    <!-- 表格自适应 + 序号 -->
    <div style="width:100%;overflow-x:auto;">
      <el-table :data="tableData"
                :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                border
                highlight-current-row
                @current-change="selectCurrentChange"
                width="100%"
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="name" label="姓名"  align="center"></el-table-column>
        <el-table-column prop="deptName" label="部门"  align="center"></el-table-column>
        <el-table-column prop="sex" label="性别"  align="center">
          <template slot-scope="scope">
            <el-tag
                :type="scope.row.sex === 1 ? 'primary' : 'success'"
                disable-transitions>{{scope.row.sex === 1 ? '男' : '女'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="roleId" label="角色"  align="center">
          <template slot-scope="scope">
            <el-tag
                :type="scope.row.roleId === 0 ? 'danger' : (scope.row.roleId === 1 ? 'primary' : 'success')"
                disable-transitions>{{scope.row.roleId === 0 ? '超级管理员' :
                (scope.row.roleId === 1 ? '管理员' : '用户')}}</el-tag>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20,30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top:10px;text-align:right">
    </el-pagination>

    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">

        <el-form-item label="名字" prop="name">
          <el-col :span="20">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="部门" prop="deptId">
          <el-col :span="20">
            <el-select v-model="form.deptId" placeholder="请选择部门" style="width:100%">
              <el-option
                  v-for="item in deptList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.deptName">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group v-model="form.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" style="font-size: 18px;"> 取 消</el-button>
        <el-button type="primary" @click="save" style="font-size: 18px;"> 确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SelectUser",
  data() {
    return {
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      name: '',
      sex: '',
      deptId: '',
      sexs: [
        {value: '1', label: '男'},
        {value: '0', label: '女'}
      ],
      deptList: [],
      centerDialogVisible: false,
      form: {
        id: '',
        no: '',
        name: '',
        password: '123456',
        phone: '',
        sex: '0',
        roleId: '2',
        deptId: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入名字', trigger: 'blur'}
        ],
        deptId: [
          {required: true, message: '请选择部门', trigger: 'change'}
        ]
      }
    }
  },
  methods: {
    loadDept() {
      this.$axios.get(this.$httpUrl + "/dept/list")
          .then(res => res.data)
          .then(res => {
            if (res.code === 200) {
              this.deptList = res.data
            }
          })
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    del(id) {
      this.$axios.get(this.$httpUrl + '/user/del?id=' + id).then(res => res.data).then(res => {
        if (res.code == 200) {
          this.$message({message: '操作成功！', type: 'success'});
          this.loadPost()
        } else {
          this.$message({message: '操作失败！', type: 'error'});
        }
      })
    },
    mod(row) {
      this.centerDialogVisible = true
      this.$nextTick(() => {
        this.form.id = row.id
        this.form.name = row.name
        this.form.sex = row.sex + ''
        this.form.deptId = row.deptId
      })
    },
    add() {
      this.centerDialogVisible = true
      this.form = {
        id: '',
        no: '',
        name: '',
        password: '123456',
        phone: '',
        sex: '0',
        roleId: '2',
        deptId: ''
      }
      this.$nextTick(() => {
        this.resetForm()
      })
    },
    doSave() {
      this.$axios.post(this.$httpUrl + '/user/save', this.form).then(res => res.data).then(res => {
        if (res.code == 200) {
          this.$message({message: '操作成功！', type: 'success'});
          this.centerDialogVisible = false
          this.loadPost()
        } else {
          this.$message({message: '操作失败！', type: 'error'});
        }
      })
    },
    doMod() {
      this.$axios.post(this.$httpUrl + '/user/update', this.form).then(res => res.data).then(res => {
        if (res.code == 200) {
          this.$message({message: '操作成功！', type: 'success'});
          this.centerDialogVisible = false
          this.loadPost()
        } else {
          this.$message({message: '操作失败！', type: 'error'});
        }
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.id ? this.doMod() : this.doSave();
        }
      });
    },
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.loadPost()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadPost()
    },
    resetParam() {
      this.name = ''
      this.sex = ''
      this.deptId = ''
      this.loadPost()
    },
    selectCurrentChange(val) {
      this.$emit("doSelectUser", val)
    },
    loadPost() {
      this.$axios.post(this.$httpUrl + '/user/listPageC1', {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        param: {
          name: this.name,
          sex: this.sex,
          roleId: '2',
          deptId: this.deptId
        }
      }).then(res => res.data).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.total
        }
      })
    }
  },
  mounted() {
    this.loadDept()
    this.loadPost()
  }
}
</script>

<style scoped>
</style>